module.exports = __webpack_public_path__ + "fonts/msyh.f80465e9.ttf";